<template>
    <div class="flex flex-col flex-grow laptop:w-2/4 laptop:mx-auto mt-5 px-5 laptop:px-0">
        <div>
            
            <h1 class="text-4xl font-bold leading-relaxed">Welcome</h1>
            <p class="m-0 text-xl leading-none">Signin to continue.</p>
        </div>
        <div class="flex flex-col mt-10">
            <label>Email:</label>
            <input
            v-model='username'
            class="border p-2 rounded"
            type="text" placeholder="e.g: hello@nomado.eu" aria-placeholder="To login, please enter your email"/>
        </div>
        <div class="flex flex-col mt-5">
            <label>Password:</label>
            <input
            v-model='password'
            @keypress.enter="auth"
            class="border p-2 rounded"
            type="password" placeholder="Your password" aria-placeholder="Please enter your password" />
        </div>
        <div class="flex flex-col mt-5">
            <a href="#" class="bg-blue text-center py-2 rounded text-white"
            @click.prevent="auth">
                Login
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            username: '',
            password: ''
        }
    },
    methods: {
        auth() {
            if (this.username == '' || this.password == '') {
                this.$notify({
                    group: 'nomado',
                    type: 'error',
                    title: 'Authentication',
                    text: 'Username or password required!'
                })
                return false
            } 
            this.doAuth(this.username, this.password)
        }
    },
    props: [
        'doAuth'
    ]
}
</script>